module.exports = __webpack_public_path__ + "static/media/29DUNON14.5bf45983.jpg";